import { Head, Link } from '@inertiajs/react'
import Form from './form.tsx'
import type { UserType } from './types.ts'
import {Button} from "@/components/ui/button.tsx";
import {ArrowLeft} from "lucide-react";

interface EditProps {
  user: UserType
}

export default function Edit({ user }: EditProps) {
  return (
    <>
      <Head title="Editing user" />

        <div className="space-y-6 p-8">
            <div className="flex items-center gap-4">
                <Link href={`/admin/users`}>
                    <Button variant="ghost" size="sm">
                        <ArrowLeft className="mr-2 h-4 w-4" />
                        Back
                    </Button>
                </Link>
                <div>
                    <h1 className="text-3xl font-bold text-foreground">Edit User</h1>
                    <p className="text-muted-foreground">Update user information and settings</p>
                </div>
            </div>

        <Form
          user={user}
          action={`/admin/users/${user.id}`}
          method="patch"
          submitText="Update User"
        />

      </div>
    </>
  )
}
